import { Component, OnInit } from '@angular/core';

import { DarkModeService } from '../../shared/services/darkmode.service';
import { HowAyrWorksCitizensComponent } from '../../shared/components/how-ayr-works-citizens/how-ayr-works-citizens.component';
import { AvoidedEmissionsComponent } from '../../shared/components/avoided-emissions/avoided-emissions.component';
import { SustainabilityPlatformComponent } from '../../shared/components/sustainability-platform/sustainability-platform.component';
import { ImageModel } from '../../model/image.model';
import { RevitalizedCompetitiveCitiesComponent } from '../../shared/components/revitalized-competitive-cities/revitalized-competitive-cities.component';
import { AyrInMyComponent } from '../../shared/components/ayr-in-my/ayr-in-my.component';
import { Title } from '@angular/platform-browser';
import { QuotesModel } from '../../shared/models/quotes.model';
import { AyrReviewsComponent } from '../../shared/components/ayr-reviews/ayr-reviews.component';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { ChooseZeroComponent } from '../../shared/components/choose-zero/choose-zero.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cities',
  imports: [
    TranslateModule,
    HowAyrWorksCitizensComponent,
    AvoidedEmissionsComponent,
    SustainabilityPlatformComponent,
    RevitalizedCompetitiveCitiesComponent,
    AyrInMyComponent,
    AyrReviewsComponent,
    CarouselModule,
    HeroSectionComponent,
    ChooseZeroComponent,
  ],
  templateUrl: './cities.component.html',
  styleUrl: './cities.component.scss',
})
export class CitiesComponent implements OnInit {
  isDarkMode!: boolean;
  comments: QuotesModel[] = [];
  public list: ImageModel[] = [];
  customOptions: OwlOptions = {
    // When carousel not needed, set false to mouseDrag, pullDrag, dots and nav
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 0,
    stagePadding: 0,
    navSpeed: 700,
    items: 1,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  constructor(
    private darkModeService: DarkModeService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('AYR | Cities');
    this.darkModeService.isDarkMode.subscribe((enabled) => {
      this.isDarkMode = enabled;
    });
    this.imagesBuilder();
    this.comments = this.quotesBuilder();
  }

  quotesBuilder(): QuotesModel[] {
    let listQuotes: QuotesModel[] = [];

    let first: QuotesModel = {
      active: true,
      companyImage:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/logos/matosinhos.webp',
      alt: 'City Hall of Matosinhos logo',
      title: 'Pilot project - Matosinhos',
      comment:
        'AYR metrics are very important to inform decision - and policy-making, as part of our decarbonization strategy.',
      commentSpanNumber: [
        {
          value: 9,
          description: 'months project duration',
        },
        {
          value: 24.012,
          description: 'active users',
        },
        {
          value: 67.016,
          description: 'trips made',
        },
        {
          value: 192.314,
          description: 'km travelled',
        },
        {
          value: 17.7,
          description: 'CO2 tons avoided',
        },
        {
          value: 176.711,
          description: 'AYR credits generated',
        },
      ],
      author: 'Luísa Salgueiro',
      authorRole: 'author_role_mayor',
    };

    listQuotes.push(first);
    return listQuotes;
  }

  imagesBuilder() {
    let home: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_02_Overview.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_02_Overview.webp',
      alt: '',
      title: 'home',
    };

    let account: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_04_Account.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_04_Account.webp',
      alt: '',
      title: 'account',
    };

    let climate: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_05_ClimateIntel.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_05_ClimateIntel.webp',
      alt: '',
      title: 'climate intelligente',
    };

    let resources: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_00_Login.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/prints/cities/City_00_Login.webp',
      alt: '',
      title: 'login',
    };

    this.list.push(home);
    this.list.push(account);
    this.list.push(climate);
    this.list.push(resources);

    return this.list;
  }
}
